import { VIF_CONSTANTS } from 'common/authoring_workflow/constants';

export default {
  format: {
    type: 'visualization_interchange_format',
    version: VIF_CONSTANTS.LATEST_VERSION
  },
  configuration: {
    viewSourceDataLink: true,
    showDataTableControl: false
  },
  description: '',
  series: [
    {
      color: {
      },
      dataSource: {
        datasetUid: null,
        dimension: {
          columnName: null,
          aggregationFunction: null,
          columns: []
        },
        measure: {
          columnName: null,
          aggregationFunction: 'count'
        },
        type: 'socrata.soql',
        filters: []
      },
      label: null,
      type: 'table',
      unit: {
        one: 'row',
        other: 'rows'
      }
    }
  ],
  title: ''
};
